import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-ohlc-series-options',
	templateUrl:'./AgOhlcSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgOhlcSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgOhlcSeriesPluginCompPage
{
	mdContent_746 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgOhlcSeriesOptions;
\`\`\``;
}
